import React from "react";
import {View, Box} from "@unibuddy/patron";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";
import Landing from "../Landing/Landing";
import {DesktopAuthCarouselLayout} from "../../Layout/DesktopAuthLayout/DesktopAuthLayout";
import {useLocationQuery} from "ubcommunity-shared/src/Hooks/useLocationQuery";
import background from "../../Layout/DesktopAuthLayout/image/star_background.png";
import {SignUpSources} from "ubcommunity-shared/src/constants";
import {StyledBox} from "../../Layout/DesktopAuthLayout/DesktopAuthLayout";

import {SharedLandingV2} from "./SharedLandingV2";

export function DesktopLandingV2() {
    usePageTitle();

    const query = useLocationQuery();
    const source = query.get("source");
    const inviteId = query.get("inviteId");

    if (source && inviteId) {
        return (
            <View flex="1" style={{backgroundImage: `url(${background})`}} minH="fit-content">
                <View flex="1" alignItems="center" justifyContent="center" minH={0}>
                    <Box minW={["100%", 375]} maxW={450} w="40%" padding="medium" maxH="100vh">
                        <StyledBox
                            bgColor="white"
                            shadow="large"
                            borderRadius="xsmall"
                            position="relative"
                        >
                            <SharedLandingV2 inviteId={inviteId} source={source as SignUpSources} />
                        </StyledBox>
                    </Box>
                </View>
            </View>
        );
    }

    return (
        <DesktopAuthCarouselLayout>
            <Landing />
        </DesktopAuthCarouselLayout>
    );
}
